// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import api from './api/index.js'
import $ from 'jquery'
import utils from './utils/index.js'
import axios from 'axios'
// import 'amfe-flexible'
Vue.config.productionTip = false
Vue.prototype.$api = api
Vue.prototype.$utils = utils
Vue.prototype.$axios=axios
Vue.prototype.$baseUrl = process.env.BASE_URL

import VueAwesomeSwiper from 'vue-awesome-swiper'
Vue.use(VueAwesomeSwiper)
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)

 axios.defaults.withCredentials = true; // 允许携带cookie
// 从浏览器 URL 中解析 lang 参数（兼容 history 模式的 search 与 hash）
function getUrlLang() {
  var urlParams = new URLSearchParams(window.location.search);
  var lang = urlParams.get('lang');
  if (lang) {
    return lang;
  }
  var hash = window.location.hash || '';
  var hashIndex = hash.indexOf('?');
  if (hashIndex > -1) {
    var hashParams = new URLSearchParams(hash.substring(hashIndex + 1));
    lang = hashParams.get('lang');
  }
  return lang || '';
}

// 运营商入口的 lang 只用于首次初始化。移除它后，用户在站内手动切换语言
// 再刷新页面时就不会被入口语言覆盖，其他查询参数和 hash 均会保留。
function removeUrlLang() {
  if (!window.history || !window.history.replaceState) {
    return;
  }

  var currentUrl = new URL(window.location.href);
  currentUrl.searchParams.delete('lang');

  var hash = currentUrl.hash || '';
  var hashIndex = hash.indexOf('?');
  if (hashIndex > -1) {
    var hashPath = hash.substring(0, hashIndex);
    var hashParams = new URLSearchParams(hash.substring(hashIndex + 1));
    hashParams.delete('lang');
    var hashQuery = hashParams.toString();
    currentUrl.hash = hashQuery ? hashPath + '?' + hashQuery : hashPath;
  }

  window.history.replaceState(null, '', currentUrl.toString());
}
// 多语言实例
var urlLang = getUrlLang();
if (urlLang) {
  localStorage.setItem('lang', urlLang);
  removeUrlLang();
}
const i18n = new VueI18n({
  locale: urlLang || localStorage.getItem('lang') || 'bur',
  messages: {
    'bur': require('./assets/i18n/bur'),   // 中文语言包
    'en': require('./assets/i18n/en')    // 英文语言包
   // 'my': require('./assets/i18n/my')    // 英文语言包
  }
})

router.beforeEach((to, from, next) => {
	// to来自  from  去哪
	if(to.meta.title) {
		document.title = to.meta.title
	}
	next()
})

let baseDownloadUrl = '' // 域名
    Vue.directive('down', {
      inserted: (el, binding) => {
        el.style.cssText = 'cursor: pointer;color:write;'
        el.addEventListener('click', () => {
          console.log(binding.value)
          let link = document.createElement('a')
          let url = baseDownloadUrl + binding.value
          console.log(url)
          // 这里是将url转成blob地址，
          fetch(url).then(res => res.blob()).then(blob => { // 将链接地址字符内容转变成blob地址
            link.href = window.URL.createObjectURL(blob)
            console.log(link.href)
            link.download = ''
            document.body.appendChild(link)
            link.click()
          })
        })
      }
    })

import { List } from 'vant';
Vue.use(List);
/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js